import { render, staticRenderFns } from "./role-permissions.vue?vue&type=template&id=8504b968&scoped=true&"
import script from "./role-permissions.vue?vue&type=script&lang=js&"
export * from "./role-permissions.vue?vue&type=script&lang=js&"
import style0 from "./role-permissions.vue?vue&type=style&index=0&id=8504b968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8504b968",
  null
  
)

export default component.exports